var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1C6.55228 1 7 1.44772 7 2V5.99829C7 5.99886 7 5.99943 7 6C7 6.00057 7 6.00114 7 6.00171V14.8C7 15.3766 7.00078 15.7488 7.02393 16.0322C7.04612 16.3038 7.0838 16.4045 7.10899 16.454C7.20486 16.6421 7.35785 16.7951 7.54601 16.891C7.59545 16.9162 7.69617 16.9539 7.96784 16.9761C8.25117 16.9992 8.62345 17 9.2 17L17.9984 17C17.9989 17 17.9995 17 18 17C18.0005 17 18.0011 17 18.0016 17H22C22.5523 17 23 17.4477 23 18C23 18.5523 22.5523 19 22 19H19V22C19 22.5523 18.5523 23 18 23C17.4477 23 17 22.5523 17 22V19L9.16143 19C8.63429 19 8.17954 19 7.80497 18.9694C7.40963 18.9371 7.01641 18.8658 6.63803 18.673C6.07354 18.3854 5.6146 17.9265 5.32698 17.362C5.13419 16.9836 5.06287 16.5904 5.03057 16.195C4.99996 15.8205 4.99998 15.3657 5 14.8385L5 7H2C1.44772 7 1 6.55228 1 6C1 5.44771 1.44772 5 2 5H5V2C5 1.44772 5.44771 1 6 1ZM16.0322 7.02393C15.7488 7.00078 15.3766 7 14.8 7H10C9.44772 7 9 6.55228 9 6C9 5.44771 9.44772 5 10 5L14.8385 5C15.3657 4.99998 15.8205 4.99996 16.195 5.03057C16.5904 5.06287 16.9836 5.13418 17.362 5.32698C17.9265 5.6146 18.3854 6.07354 18.673 6.63803C18.8658 7.01641 18.9371 7.40963 18.9694 7.80497C19 8.17954 19 8.63429 19 9.16143V14C19 14.5523 18.5523 15 18 15C17.4477 15 17 14.5523 17 14V9.2C17 8.62345 16.9992 8.25117 16.9761 7.96783C16.9539 7.69617 16.9162 7.59545 16.891 7.54601C16.7951 7.35785 16.6422 7.20487 16.454 7.10899C16.4045 7.0838 16.3038 7.04612 16.0322 7.02393Z",
    fill: "#0157FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrop);
export default __webpack_public_path__ + "static/media/crop.77d29ac0c5b429e5ab3de2a18107dec2.svg";
export { ForwardRef as ReactComponent };